<script setup lang="ts">
import { LucideEye, LucideEyeOff } from 'lucide-vue-next'

defineProps<{ show: boolean }>()
const emit = defineEmits<{ (e: 'toggle'): void }>()

const { t } = useI18n()
</script>

<template>
  <button
    type="button"
    class="absolute inset-y-0 right-3 flex items-center justify-center text-gray-500 hover:text-gray-600"
    :aria-label="show ? t('common.hide_password') : t('common.show_password')"
    @click="emit('toggle')"
  >
    <LucideEyeOff v-if="!show" class="h-5 w-5" />
    <LucideEye v-else class="h-5 w-5" />
  </button>
</template>
